// Import Core
import React from 'react';
import styled from 'styled-components';
import IconButton from './buttons/IconButton';
import Popover from './Popover';
import usePopover from '../../utils/usePopover';

const IconListStyling = styled.div`
	&.default {
		padding: var(--global-padding);
		display: flex;
		flex-wrap: wrap;
		row-gap: 20px;
		@media (max-width: 768px) {
			flex-direction: column;
			padding: var(--global-padding-mobile);
			row-gap: 24px;
		}
		.icon-list-item {
			flex: 25%;
			padding: 0 32px;
			border-right: 1px solid var(--neutral-10);
			display: flex;
			flex-direction: column;
			gap: 24px;
			&:first-child {
				padding: 0 32px 20px 0;
			}
			&:last-child {
				padding-right: 0;
				border-right: none;
			}
			@media screen and (max-width: 1200px) {
				/* TODO: CHECK SPACINGS AND FIX 20PX/32PX ETC */
				flex: calc(50% - 10px);
				&:first-child,
				&:nth-child(2) {
					position: relative;
					margin-bottom: 20px;
					&:before {
						content: '';
						position: absolute;
						bottom: -20px;
						left: 0;
						height: 1px;
						width: 100%;
						border-bottom: 1px solid var(--neutral-10);
					}
				}
				&:nth-child(3) {
					padding-left: 0;
				}
				&:nth-child(2) {
					padding-right: 0;
					border-right: none;
					padding-left: 20px;
					/* margin-left: ; */
				}
			}
			@media (max-width: 768px) {
				flex: unset;
				gap: 20px;
				border-right: none;
				border-bottom: 1px solid var(--neutral-10);
				padding: 0 0px 24px 0;
				&:first-child,
				&:nth-child(2) {
					margin-bottom: 0px;
					padding: 0 0px 24px 0;
					&:before {
						content: none;
					}
				}
				&:last-child {
					padding-bottom: 0;
					border-bottom: none;
				}
			}
			.list-icon {
				width: 48px;
				height: 48px;
			}
			.link {
				color: var(--neutral-75);
				text-decoration: underline;
			}
		}
	}
	&.minimal {
		display: flex;
		align-items: flex-end;
		align-content: flex-end;
		gap: 10px 16px;
		align-self: stretch;
		flex-wrap: wrap;
		@media (max-width: 768px) {
			gap: 8px 16px;
		}

		.icon-list-item {
			display: flex;
			align-items: center;
			gap: 8px;
			.list-icon {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 24px;
				height: 24px;
				gap: 8px;
				background: var(--red-light);
				border-radius: 4px;
				svg {
					width: 16px;
					height: 16px;
					padding: 0;
					background-color: transparent;
					color: var(--red-75);
				}
        .icon-name {
          color: var(--neutral-75);
        }
			}
		}
		

    .popover-content {
      .icon-list-item {
        .list-icon {
          .icon-name {
            color: var(--white);
          }
        }
      }
    }
	}
	&.col-layout {
		flex-direction: column;
		align-items: flex-start;
		align-content: flex-start;
	}
`;

const IconItem = ({ index, list, iconLayout, showDescriptions }) => {
	return (
		<div key={index} className='icon-list-item'>
			<IconButton
				className='list-icon'
				clickHandler={undefined}
				isDisabled={false}>
				{list.icon}
			</IconButton>
			{iconLayout === 'default' ? (
				<h4 className='alt'>{list.title}</h4>
			) : (
				<div className="text">
					
					{(showDescriptions && list.description) ? (
						<p className='icon-description'>{list.description}</p>
					) : (
						<p className='icon-name'>{list.title}</p>
					)}
				</div>
			)}
			{list.content && (
				<div className='content'>
					{list.content.split(',').map((item) => (
						<p key={item}>{item}</p>
					))}
				</div>
			)}
			{list.link && list.link_text && (
				<a href={list.link} className='link'>
					{list.link_text}
				</a>
			)}
		</div>
	);
};
const IconList = ({
	id,
	iconListItems,
	iconLayout = 'default',
	addPopover = false,
	popoverListItems,
	addText = false,
	showDescriptions = false
}) => {
	const [isPopoverActive, activePopoverId, togglePopover] = usePopover();

	return (
		<IconListStyling className={`icon-list ${iconLayout}${showDescriptions ? ' col-layout' : ''}`}>
			{addText && <p className="bold">Includes</p>}
			{iconListItems.map((list, index) => (
				<IconItem index={index} list={list} iconLayout={iconLayout} key={index} showDescriptions={showDescriptions} />
			))}
			{addPopover && popoverListItems && popoverListItems.length > 0 && (
				<Popover
					id={`${id}-popover`}
					isPopoverActive={isPopoverActive}
					activePopoverId={activePopoverId}
					togglePopover={togglePopover}
					showClose={false}
					placement='top'
					trigger={
						<p className='includes-popover'>{`+${popoverListItems.length}`}</p>
					}
					content={popoverListItems.map((list, index) => (
						<IconItem index={index} list={list} iconLayout={iconLayout} showDescriptions={false} />
					))}
				/>
			)}
		</IconListStyling>
	);
};

export default IconList;
